import { get } from '@/services/http';

export class EtlProcessModel {
  constructor(data: any = {}) {}

  public async trigger() {
    await get('/etl/trigger_all');
  }
}
